module.exports = __webpack_public_path__ + "img/logo.9550fa9c.svg";